import { ApolloQueryResult } from '@apollo/client';
import { PartnerLinksResponse } from './api/types';
import { Location, PartnerProfilePartnerLinks, PartnerProfilePartnerLinksMetrics } from '@trnsact/trnsact-shared-types';
import { UserProfile } from 'types';

export interface DealerManagementPartnerLink extends PartnerLink {
  status: string;
  activeMenus: string[];
  recentQuotes: number;
  recentContracts: number;
  metrics: PartnerProfilePartnerLinksMetrics;
}

export interface DealerManagementCellArgs {
  original: DealerManagementPartnerLink;
}

export interface PartnerLink extends PartnerProfilePartnerLinks {
  accountName: string; // to overwrite "Maybe" type coming from trnsact-shared-types
  accountId: string;
  partnerLocations: Location[];
}

export interface AddDealerFormInputs {
  name: string;
  numberOfQuotesYearly: string;
  numberOfContractsYearly: string;
  summaryOfRelationship: string;
  contact: AddDealerFormContactInputs;
}

export interface AddDealerFormContactInputs {
  firstName: string;
  lastName: string;
  title: string;
  email: string;
  phone: string;
}

export type AftermarketPartnerAddDealerDialogData = {
  refetchPartnerLinks: () => Promise<ApolloQueryResult<PartnerLinksResponse>>;
};

export type AftermarketPartnerAddLocationDialogData = {
  accountDynamicsId: string;
  dealerContacts: UserProfile[];
  refetchDealerAccount: () => Promise<ApolloQueryResult<any>>;
};

export interface AddLocationFormInputs {
  locationName: string;
  ocaContactId: string;
}

export enum ProposalsPageButtonGroupOptions {
  Dashboard = 'Dashboard',
  DealerProposals = 'Dealer Proposals',
  YourProposals = 'Your Proposals',
}

export enum DealerManagementTabs {
  DealerManagement = 'dealerManagement',
  Broadcasts = 'broadcasts',
}
